import { render, staticRenderFns } from "./GLCodeSetup.vue?vue&type=template&id=6ddf0bbc&scoped=true"
import script from "./GLCodeSetup.vue?vue&type=script&lang=js"
export * from "./GLCodeSetup.vue?vue&type=script&lang=js"
import style0 from "./GLCodeSetup.vue?vue&type=style&index=0&id=6ddf0bbc&prod&scoped=true&lang=css"
import style1 from "./GLCodeSetup.vue?vue&type=style&index=1&id=6ddf0bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf0bbc",
  null
  
)

export default component.exports